/**
 * Created by emanuele on 29/05/2017.
 */
import React from 'react';
import QueryFilter from '../QueryFilter'

const QueryFilterMovimenti = (props) => (
    <QueryFilter {...props} >
        <p>Campi utilizzabili nella query:</p>
        <ul>
            <li>m.idMovimento</li>
            <li>m.data</li>
            <li>m.annoComp</li>
            <li>m.soggetto</li>
            <li>m.corrispettivo</li>
            <li>m.pagamento</li>
            <li>m.causale</li>
            <li>m.forma</li>
            <li>m.entrUsc (Valori possibili: E, U)</li>
            <li>m.prevDef (Valori possibili: P, D)</li>
            <li>m.estrConto</li>
            <li>p.catProg</li>
            <li>p.catDesc</li>
            <li>p.voxProg</li>
            <li>p.voxDesc</li>
            <li>p.subProg</li>
            <li>p.subDesc</li>
            <li>c.codice</li>
            <li>c.nome</li>
            <li>c.oggetto</li>
        </ul>
        <p>Operatori utilizzabili nella query:</p>
        <ul>
            <li><code>=, &#x3C;, &#x3C;=, &#x3E;, &#x3E;=, &#x3C;&#x3E;, !=, like, and, or</code></li>
        </ul>
        <p><b>Esempio: </b> m.entrUsc = 'U' and m.prevDef = 'D' <em>(tutti i movimenti di uscita definitivi)</em><br/>
            <b>Esempio: </b> m.estrConto like '%/A' <em>(tutti gli estratti conto di tipo A)</em><br/>
            <b>Esempio: </b> m.estrConto like '2017/__/A' <em>(tutti gli estratti conto del 2017 di tipo A)</em><br/>
            <b>Esempio: </b> p.catDesc = 'banche' <em>(tutti i movimenti della categoria 'banche')</em><br/>
            <b>Esempio: </b> c.codice = 'ABC' <em>(tutti i movimenti della commessa con codice ABC)</em></p>
        <p>Premere il tasto di <b>conferma</b> per applicare la condizione.</p>
    </QueryFilter>
);


export default QueryFilterMovimenti;


/** WEBPACK FOOTER **
 ** ./src/components/movimenti/QueryFilterMovimenti.js
 **/